<h2 mat-dialog-title>Elimina Utente</h2>
<hr>
<mat-dialog-content class="container" id="delete-user-container">
    <p>Eliminare l'utente <i>{{ data.user.username }}</i></p>
</mat-dialog-content>
<hr>
<mat-dialog-actions id="action-div">
    <button mat-stroked-button (click)="closeCancelling()" type="button">Annulla</button>
    <button mat-stroked-button color="warn" (click)="closeConfirming()">Elimina</button>
</mat-dialog-actions>